/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { AdvantageAbout } from "json/landingPageData";

const AdvAbout = () => {
  const advantages = AdvantageAbout.flat();
  const [cardNumber, setCardNumber] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const currentCard = advantages[cardNumber];

  return (
    <section className="px-8">
      <div className="container mx-auto lg:max-w-screen-xl">
        <div className="mb-16 text-center mx-auto">
          <h2 className=" mb-4 text-2xl font-bold lg:text-5xl text-theme-blue dark:text-white">
            Who We Are
          </h2>
          <p className="text-base lg:text-lg font-light text-gray-400 max-w-xl mx-auto">
            We’re a technology company redefining how buildings are connected,
            automated and optimised – ensuring they are intuitive, scalable, and
            ready for the future.
          </p>
        </div>
        <div className="mb-14 grid h-full grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-4 ">
          {advantages.map((item, index) => (
            <div
              key={index}
              role="button"
              tabIndex={0}
              onMouseEnter={() => setCardNumber(index)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setCardNumber(index);
                }
              }}
              className={`cursor-pointer rounded-lg p-4 transition-opacity duration-300 ${cardNumber === index ? "opacity-100" : "opacity-100"

                }  ring-2 ring-theme-teal border dark:ring-theme-tarjet dark:bg-theme-tarjet`}
            >
              <div className="flex flex-col items-start gap-2 text-left">
                <div className="w-6 h-6 mb-1">
                  {typeof item.logo === "string" ? (
                    <img
                      src={item.logo}
                      alt="Logo"
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    item.logo
                  )}
                </div>
                {(item.title) && (
                  <h3 className="text-base lg:text-lg font-semibold text-theme-teal dark:text-white">
                    {item.title}
                  </h3>
                )}
                {(item.description) && (
                  <p className="text-base font-light text-gray-500">
                    {item.description}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="rounded-t-[28px] overflow-hidden border border-gray-200 dark:border-theme-border">
          <img
            src={
              isMobile && currentCard.imagemobile
                ? currentCard.imagemobile
                : currentCard.image
            }
            alt={currentCard.title}
            className="w-full h-[300px] object-cover object-center transition-all duration-500 transition-transform duration-300 block dark:hidden "
          />
          <img
            src={
              isMobile && currentCard.imagemobileDark
                ? currentCard.imagemobileDark
                : currentCard.imageDark
            }
            alt={currentCard.title}
            className="w-full h-[300px] object-cover object-center transition-all duration-500 transition-transform duration-300 hidden dark:block "
          />
        </div>
      </div>
    </section>
  );
};

export default AdvAbout;
